document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const closeAllDrawers = () => {
    document.querySelectorAll('[data-drawer]').forEach((drawer) => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    });
    body.classList.remove('drawer-open');
  };

  document.querySelectorAll('[data-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const id = trigger.getAttribute('data-drawer-open');
      const drawer = document.getElementById(id);
      if (!drawer) return;
      closeAllDrawers();
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open');
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach((trigger) => {
    trigger.addEventListener('click', closeAllDrawers);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllDrawers();
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-accordion-item]');
      if (!item) return;
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      const value = Number(input.value || min);
      input.value = button.dataset.quantityButton === 'plus'
        ? value + step
        : Math.max(min, value - step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
